import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/undo.svg
 */
const IconUndo: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M6.816 12c0 .053.007.104.021.155 0 .026 0 .056.013.08.012.025.04.042.057.067s.017.057.037.08l4.15 4.725a.59.59 0 10.887-.774L8.692 12.59h8.827a.592.592 0 000-1.182H8.692l3.29-3.745a.588.588 0 00-.125-.886.59.59 0 00-.763.107l-4.15 4.724c-.02.023-.021.054-.037.08-.015.027-.045.04-.057.067-.012.028 0 .055-.013.083a.544.544 0 00-.021.162z"
      fill="currentColor"
    />
    <path
      d="M11.998 0A12.001 12.001 0 110 12 12.036 12.036 0 0111.998 0zm0 22.516A10.518 10.518 0 101.483 12a10.546 10.546 0 0010.515 10.516z"
      fill="currentColor"
    />
  </svg>
);

export default IconUndo;
